import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/service-offer";


export const OfferDetails = async () => {
  return await axiosInstance(options).get(`${path}/details`);
};
export const AddOffer = async (values) => {
  return await axiosInstance(options).post(`${path}/add`, values);
}



